<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading :heading="competence.name">
      <span slot="before">
         <back-link style="margin-bottom: 5px" :link="{ name: 'EvalCompetencies' }" text="В библиотеку компетенций"></back-link>
      </span>
    </page-heading>
    <div>
      <el-tabs value="indicators">
        <el-tab-pane label="Настройки индикаторов" name="indicators">
          <el-card>
            <indicators-component></indicators-component>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="Настройки рекомендаций" name="recommendations">
          <el-card>
            <ranges-recommendation></ranges-recommendation>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import BackLink from "@/components/BackLink.vue";
import IndicatorsComponent from "@/modules/evaluation/components/indicator/IndicatorsComponent.vue";
import RangesRecommendation from "@/modules/evaluation/components/recommendation/RangesRecommendation.vue";

export default {
  name: 'eval-competence',
  components: {
    BackLink,
    PageHeading,
    RangesRecommendation,
    IndicatorsComponent
  },
  data() {
    return {
      loading: false,
      competence: [],
    }
  },
  mounted() {
    this.getCompetence();
  },
  methods: {
    getCompetence() {
      this.loading = true;
      this.$api.evaluation.competenceGet({
        id: this.$route.params.id,
      })
        .then(data => {
          this.competence = data.competence;
        })
        .finally(() => {
        this.loading = false;
        });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>